import { NiaraIcon } from '@niaratech/niara-icons'
import styled from 'styled-components'

export type OpenTabProps = {
  isOpen?: boolean
  paddingHeader?: number | string
  paddingHeaderY?: number
  childrenPaddingX?: number
  childrenPaddingY?: number
  sizeHeaderText?: number
  transition?: boolean
  colorDivider?: string
}

export type TitleProps = {
  sizeTitle?: number
}

export const Tab = styled.div<OpenTabProps>`
  background-color: ${({ theme }) => theme?.colors?.white};
  border-radius: 4px 4px 0 0;
  cursor: pointer;
  justify-content: space-between;
  position: relative;
  width: 100%;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    font-family: Manrope;
    margin-bottom: 0px;
    margin-top: 0px;
  }

  & + div {
    border-radius: 0;
    &::before {
      background-color: ${({ colorDivider }) => (colorDivider ? colorDivider : '#e9e9e9')};
      content: '';
      height: 1px;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 1;
    }
  }
`

export const Hero = styled.div<OpenTabProps>`
  align-items: center;
  background-color: ${({ theme }) => theme?.colors?.white};
  border-radius: 2px;
  display: flex;
  padding: ${({ paddingHeader }) => paddingHeader && paddingHeader}px;
  padding-block: ${({ paddingHeaderY }) => paddingHeaderY && paddingHeaderY}px;
  width: 100%;

  div {
    display: flex;
    color: ${({ theme }) => theme?.colors?.textColor};
    cursor: pointer;
    flex: 1;
    font-size: ${({ sizeHeaderText }) => sizeHeaderText ?? '16px'}px;
    font-weight: 700;
    margin: 0;
  }
`

export const RotatingIcon = styled(NiaraIcon)`
  &.chevron-animation {
    transition: ease-in-out 0.3s;
  }

  &.open {
    transform: rotate(180deg);
  }

  &.closed {
    transform: rotate(0deg);
  }
`

export const Icon = styled.img`
  height: 18px;
  margin-right: 10px;
`

export const ExpandIcon = styled.img<OpenTabProps>`
  cursor: pointer;
  transition: ease-in-out 0.3s;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 0)};
`

export const Content = styled.div<OpenTabProps>`
  background-color: ${({ theme }) => theme?.colors?.white};
  cursor: default;
  height: ${({ isOpen }) => (isOpen ? 'auto' : 0)};
  padding-inline: ${({ childrenPaddingX }) => childrenPaddingX && childrenPaddingX}px;
  padding-block: ${({ childrenPaddingY }) => childrenPaddingY && childrenPaddingY}px;
  padding: ${({ isOpen, childrenPaddingX, childrenPaddingY }) =>
    isOpen ? `${childrenPaddingY}, ${childrenPaddingX}` : '0'};
  transition: ${({ transition }) => (transition ? 'ease-out 0.3s' : '')};
  overflow: ${({ isOpen }) => (isOpen ? '' : 'hidden')};
  width: 100%;
`

export const Title = styled.p<TitleProps>`
  font-size: ${({ sizeTitle }) => sizeTitle ?? '14'}px;
  font-weight: 700;
  line-height: 20px;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
`
